import DragController from 'components/drag-controller/DragController';
import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import store from 'store';
export default class Facets extends Component {
    activeItem = null;
    mo;
    getModulesMap() {
        return {
            facets: ['self', DragController]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            gradient: true
        };
    }
    initialized() {
        super.initialized();
        this.detectActive();
    }
    detectActive = () => {
        const activeItem = this.refs.draggableItems.find((item) => item.getAttribute('href') === window.location.href);
        if (activeItem) {
            this.activeItem = activeItem;
            this.refs.draggableItems.forEach((item) => {
                item.classList.add('inactive');
            });
            this.activeItem.classList.remove('inactive');
        }
        else {
            this.refs.draggableItems.forEach((item) => {
                item.classList.remove('inactive');
                this.activeItem = null;
            });
        }
    };
    bindEvents(add) {
        const method = bindMethod(add);
        this.refs.draggableItems.forEach((item) => {
            item[method]('mouseenter', (e) => this.onMouseEnter(e));
            item[method]('mouseleave', (e) => this.onMouseLeave(e));
        });
        store.fullPath.toggleListener(add, this.detectActive);
    }
    onClick = (e) => {
        const target = e.currentTarget;
        if (target.getAttribute('href').includes('?') && window.location.href === target.getAttribute('href')) {
            this.refs.draggableItems.forEach((item) => {
                item.classList.add('inactive');
            });
            target.classList.remove('inactive');
            this.activeItem = target;
        }
    };
    onMouseEnter = (e) => {
        const target = e.currentTarget;
        this.refs.draggableItems.forEach((item) => {
            item.classList.add('inactive');
        });
        target.classList.remove('inactive');
    };
    onMouseLeave = (e) => {
        this.refs.draggableItems.forEach((item) => {
            if (this.activeItem) {
                if (item === this.activeItem)
                    item.classList.remove('inactive');
                else
                    item.classList.add('inactive');
            }
            else {
                item.classList.remove('inactive');
            }
        });
    };
}
